<template>
  <v-container fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">应用管理</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">应用列表</v-subheader>
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click.stop="AddApp"> <v-icon left>mdi-plus</v-icon>新增 </v-btn>
          </v-card-actions>
          <v-card-text>
            <div class="table-filter">
              <div class="box">
                <span class="label">appCode</span>
                <v-text-field v-model="filterForm.appCode" outlined placeholder="请输入" solo></v-text-field>
              </div>
              <div class="box">
                <span class="label">名称</span>
                <v-text-field v-model="filterForm.appName" outlined placeholder="请输入" solo></v-text-field>
              </div>
              <div class="box">
                <span class="label">类型</span>
                <v-select v-model="filterForm.appUserType" outlined :items="userTypes" label="请输入" solo></v-select>
              </div>
              <v-btn @click.stop="reset" class="margin-left-2x">重 置</v-btn>
              <v-btn color="primary" @click.stop="getList('filter')" class="margin-left-2x">查 询</v-btn>
            </div>
            <v-data-table :headers="headers" :items="desserts" :options.sync="pagination" :server-items-length="totalDesserts" :loading="loading" class="elevation-1">
              <template v-slot:[`item.appIconUrl`]="{ item }">
                <v-avatar class="img" size="36">
                  <img :src="imgSrcTimestamp(item.masterImg)" :onerror="defaultAppIcon" />
                </v-avatar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'detail')">查看</v-btn>
                <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'edit')">编辑</v-btn>
                <v-btn class="ma-2 white--text" small color="error" @click="clickAction(item, 'delete')">删除</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">删除应用</span>
        </v-card-title>
        <v-card-text class="pb-0"> 确定要删除该应用？<br /> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="deleteItem" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import { imgSrcTimestamp } from '@/plugins/utils'
export default {
  name: 'AppInfo',
  components: {
  },
  data () {
    return {
      totalDesserts: 0,
      pagination: { page: 1, itemsPerPage: 10 },
      loading: true,
      userTypes: [
        {
          text: '用户',
          value: 'user'
        },
        {
          text: '商户',
          value: 'mercacc'
        },
        {
          text: '通用',
          value: 'common'
        }
      ],
      headers: [
        { text: '图标', value: 'appIconUrl' },
        { text: 'appCode', value: 'appCode' },
        { text: '名称', value: 'appName' },
        // { text: '用户类型', value: 'appUserType' },
        { text: '英文名称', value: 'appNameEn' },
        { text: '操作', value: 'actions' }
      ],
      filterForm: {
        appCode: '',
        appName: '',
        appUserType: ''
      },
      desserts: [],
      appList: [],
      deleteDialog: false,
      currentItem: {},
      obj: {
        aaa: '1111'
      },
      defaultAppIcon: 'this.src="' + require('@/assets/icon/example.svg') + '"'
    }
  },
  computed: {
  },

  watch: {
    pagination: {
      handler () {
        this.getList()
      },
      deep: true
    }
  },

  created () {
  },
  methods: {
    imgSrcTimestamp,
    AddApp () {
      this.$router.push({ name: 'appAdd' })
    },
    reset () {
      Object.keys(this.filterForm).forEach((key) => {
        this.filterForm[key] = ''
      })
    },
    // list
    getList (type) {
      let str = ''
      if (type === 'filter') {
        this.pagination.page = 1
        Object.keys(this.filterForm).map((key) => {
          if (this.filterForm[key]) {
            str = str + '&' + key + '=' + this.filterForm[key]
          }
        })
      }
      // this.pagination.page = 1
      const request = buildAxios()
      request.get('baseApp/page?page=' + (this.pagination.page - 1) + '&size=' + this.pagination.itemsPerPage + str)
        .then(res => {
          this.loading = false
          this.totalDesserts = res.data.data.totalSize
          const data = res.data.data.data
          data.forEach(item => {
            if (item.extraConfig.img) {
              const masterImgObj = item.extraConfig.img.find(item => {
                return item.src !== ''
              })
              this.$set(item, 'masterImg', masterImgObj ? masterImgObj.src : '')
            }
            console.log(item.appName, item.extraConfig.img)
          })
          this.desserts = data
          // this.desserts = []
          // data.forEach(item => {
          //   if (item.extraConfig.img) {
          //     const masterImgObj = item.extraConfig.img.find(item => {
          //       return item.src !== ''
          //     })
          //     this.$set(item, 'masterImg', masterImgObj ? masterImgObj.src : '')
          //   }
          //   console.log(item.appName, item.authMethods)
          //   if (!item.extraConfig || item.extraConfig.showTitle !== 1) {
          //     this.desserts.push(item)
          //   }
          // })
          // console.log(this.appList)
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // action
    clickAction (item, type) {
      this.currentItem = item
      localStorage.setItem('appDetail', JSON.stringify(item))
      if (type === 'detail') {
        this.$router.push({ name: 'appDetail', query: { appCode: item.appCode } })
      } else if (type === 'edit') {
        this.$router.push({ name: 'appAdd', query: { appCode: item.appCode } })
      } else if (type === 'delete') {
        this.deleteDialog = true
      }
    },
    // delete
    deleteItem () {
      const request = buildAxios()
      request.post('baseApp/delete', { appCode: this.currentItem.appCode }).then(res => {
        this.deleteDialog = false
        this.getList()
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    }
  },
  filters: {
  }
}
</script>
